import { render, staticRenderFns } from "./GlueList.vue?vue&type=template&id=4682be04&scoped=true&"
import script from "./GlueList.vue?vue&type=script&lang=ts&"
export * from "./GlueList.vue?vue&type=script&lang=ts&"
import style0 from "./GlueList.vue?vue&type=style&index=0&id=4682be04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4682be04",
  null
  
)

export default component.exports